const menuPathConfigs = {
  sale: '/invoicing/sale/approval/index',
  order: '/invoicing/order/index',
  dailyReport: '/synergy/daily-report/approval',
  employeeLeave: '/synergy/leave-approval/index',
  checkInRecordDetail: '/synergy/check-in-record-approval/index',
  todo: '/synergy/todo/index'
}

export { menuPathConfigs }
